import {
  Box, Typography, Paper, Grid, Avatar, Chip, CircularProgress, Alert, Divider,
} from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { staffService } from '@smartgrow/shared';

const ROLE_COLORS: Record<string, 'primary' | 'secondary' | 'warning' | 'default'> = {
  OWNER: 'primary',
  ADMIN: 'secondary',
  SUPERVISOR: 'warning',
};

export const ProfilePage = () => {
  const { data: profile, isLoading, isError } = useQuery({
    queryKey: ['profile-me'],
    queryFn: staffService.getMe,
  });

  if (isLoading) return <Box sx={{ p: 4 }}><CircularProgress /></Box>;
  if (isError || !profile) return <Alert severity="error">Failed to load profile.</Alert>;

  const initials = profile.fullName?.split(' ').map((n) => n[0]).join('').slice(0, 2).toUpperCase() ?? '?';
  const roleColor = ROLE_COLORS[profile.role] ?? 'default';

  return (
    <Box sx={{ maxWidth: 800, mx: 'auto' }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>My Profile</Typography>

      <Paper sx={{ p: 4, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, mb: 3 }}>
          <Avatar sx={{ width: 80, height: 80, bgcolor: 'primary.main', fontSize: 28 }}>
            {initials}
          </Avatar>
          <Box>
            <Typography variant="h5" fontWeight="bold">{profile.fullName}</Typography>
            <Typography variant="body1" color="text.secondary">@{profile.username}</Typography>
            <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
              <Chip label={profile.role} color={roleColor} size="small" />
              <Chip
                label={profile.active ? 'Active' : 'Inactive'}
                color={profile.active ? 'success' : 'error'}
                size="small"
              />
            </Box>
          </Box>
        </Box>

        <Divider sx={{ mb: 3 }} />

        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="text.secondary">Email</Typography>
            <Typography variant="body1">{profile.email ?? '—'}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="text.secondary">Phone</Typography>
            <Typography variant="body1">{(profile as any).phone ?? '—'}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="text.secondary">Username</Typography>
            <Typography variant="body1">{profile.username}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="text.secondary">Role</Typography>
            <Typography variant="body1">{profile.role}</Typography>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};
